import apiClient from "./apiClient";

/**
 * Custom (per-university) discussion emoji. The built-in "Vitrine School Emojis"
 * Lottie pack lives in config/discussionEmoji; these are admin-uploaded images.
 */
const EmojiService = {
  listCustom: () => apiClient.get("/discussion-emoji"),
  createCustom: (formData) =>
    apiClient.post("/discussion-emoji", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  deleteCustom: (id) => apiClient.delete(`/discussion-emoji/${id}`),
};

export default EmojiService;
